// third-party
import { saveAs } from 'file-saver';

// ==============================|| CUSTOM FUNCTION - SAVE FILE||============================== //

const saveFile = (data, fileName) => {
  const excelApplicationType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;';
  const blob = new Blob([data], {
    type: excelApplicationType
  });
  saveAs(blob, fileName);
};

export default saveFile;
